<template>
  <div id="step-2-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step2Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'In addition to saving for a down payment, what other expenses you should consider when buying a home?',
          type: 'singleChoice',
          options: [
            'Closing costs',
            'Moving-related expenses',
            'Homeowners insurance',
            'Home maintenance costs',
            'All of the above',
          ],
          correctAnswer: 4,
          bottomHeaderTrue: 'Awesome! ',
          bottomHeaderFalse: 'Good Try.',
          bottomText:
            'These are all expenses you should consider when you are preparing to buy a home.',
        },
        {
          prompt:
            'Your debt-to-income (DTI) ratio can affect the interest rate of your mortgage.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 0,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "Your DTI ratio will be a strong factor when determining how much you'll be approved to borrow, your interest rate, and other loan terms.",
        },
        {
          prompt: 'Budgeting is not important when saving to buy a house.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 1,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Budgeting is a tried-and-true method for understanding your total income and expenses, giving you a clear view of your spending habits, and where your money is going.',
        },
      ],
    };
  },
};
</script>

<style>
</style>
